export default __webpack_public_path__ + "static/media/antp_MegaTendencias13oct_p.fe595a6d.jpg";